import { render, staticRenderFns } from "./AzurePermissionDisabledDialog.vue?vue&type=template&id=97c131f0&scoped=true"
import script from "./AzurePermissionDisabledDialog.vue?vue&type=script&lang=js"
export * from "./AzurePermissionDisabledDialog.vue?vue&type=script&lang=js"
import style0 from "./AzurePermissionDisabledDialog.vue?vue&type=style&index=0&id=97c131f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c131f0",
  null
  
)

export default component.exports